
<template>
    <!-- 83315 - Education Tab Content Example -->
    <div class="PHD__article-link-container">
        <!-- Assuming there is data to display in the key:value pairs that i'm guessing based on demo responses, the following should render the list as expected.  Presently the actualy API returns NULL for anything remotely important, as there is no content/data to display -->

        <div v-for="(item, index) in apiData.slice(0, numbertoshow)" 
            :key="index" 
            class="article-link__item">
            <a :href="item.eventLink" 
                v-html="item.eventName"
                class="PHD__article-link PHD__article-link--large">linkText</a>
            <p v-if="item.eventName" 
                v-html="item.eventDescription" 
                class="PHD__article-summary">Description</p>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: {
            uri: {
                type: String,
                default: ""
            },
            community: {
                type: Number,
                default: 2
            },
            numbertoshow: {
                type: Number,
                default: 5
            }
        },
        data() {
            return {
                apiData: []
                // demoResponse is for testing data only
                // demoResponse: {
                //     "statusCode": 200,
                //     "status": "OK",
                //     "errors": null,
                //     "result": [
                //         {
                //             "eventId": null,
                //             "eventCode": "6598455",
                //             "eventName": "Giantbomb Gaming News",
                //             "eventLink": 'http://giantbomb.com',
                //             "eventDescription": "This is a fake description for Giantbomb.com's gaming news event thingy for testing purposes.",
                //             "startDate": null,
                //             "startTime": "",
                //             "endDate": null,
                //             "endTime": "",
                //             "creditHours": "0.25",
                //             "facility": null,
                //             "facilityCity": "",
                //             "facilityState": "",
                //             "releaseDate": null,
                //             "expirationDate": null,
                //             "lmsActivityKeyword": []
                //         },
                //         {
                //             "eventId": null,
                //             "eventCode": "6598706",
                //             "eventName": "Google-a-thon",
                //             "eventLink": "https://google.com",
                //             "eventDescription": "This is a story all about how my life got flipped turned upside down, let me take a minute you just sit right there and I'll tell you how I became the prince of a town called Bel-Air.",
                //             "startDate": null,
                //             "startTime": "",
                //             "endDate": null,
                //             "endTime": "",
                //             "creditHours": "0.25",
                //             "facility": null,
                //             "facilityCity": "",
                //             "facilityState": "",
                //             "releaseDate": null,
                //             "expirationDate": null,
                //             "lmsActivityKeyword": []
                //         },
                //         {
                //             "eventId": null,
                //             "eventCode": "6598565",
                //             "eventName": "Test Event 3",
                //             "eventLink": "https://arstechnica.com",
                //             "eventDescription": "This webinar series covers evaluation of patients with cryptogenic stroke, cardiac monitoring and the role of atrial cardiopathy; and the management Strategies for patients with cryptogenic stroke. Descriptions and accreditations are shown under Activity Information. Accreditation is claimed separately on each activity. Click the Register button to purchase the bundle.",
                //             "startDate": null,
                //             "startTime": "",
                //             "endDate": null,
                //             "endTime": "",
                //             "creditHours": "0.25",
                //             "facility": null,
                //             "facilityCity": "",
                //             "facilityState": "",
                //             "releaseDate": null,
                //             "expirationDate": null,
                //             "lmsActivityKeyword": []
                //         },
                //         {
                //             "eventId": null,
                //             "eventCode": "6598565",
                //             "eventName": "Test Event 4",
                //             "eventLink": "https://polygon.com",
                //             "eventDescription": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi quis iste, nemo corporis iusto ipsam fugiat voluptate unde, neque temporibus perferendis blanditiis atque ea distinctio dolorum, dolor sed ducimus nihil!",
                //             "startDate": null,
                //             "startTime": "",
                //             "endDate": null,
                //             "endTime": "",
                //             "creditHours": "0.25",
                //             "facility": null,
                //             "facilityCity": "",
                //             "facilityState": "",
                //             "releaseDate": null,
                //             "expirationDate": null,
                //             "lmsActivityKeyword": []
                //         }
                //     ]
                // }
            }
        },
        beforeMount() {
            this.getApiData();
        },
        methods: {
            getApiData() {
                axios.get(this.uri, {
                    params: {
                        communityId: this.community
                    }
                }).then(response => {
                    this.apiData = response.data.result;
                    // console.log('***Data successfully retrieved***');
                    // console.log('apiData: ', this.apiData);
                }).catch(error => {
                    console.log('getApiData Error: ', error);
                });

                // Example Response - uncomment this line if you need to see this thing actually work
                // this.apiData = this.demoResponse.result;
            } // getApiData
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/components/phd/education-activities-list.vue